import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  PolicyDialogHeader,
  PolicyOverviewTab,
  PolicyRulesTab,
  PolicyDataFieldsTab,
  PolicyEntitiesTab,
  PolicyTestingTab,
  usePolicyDetails,
} from './PolicyDetailsComponents';

/**
 * Policy Details Component
 *
 * Displays detailed information about a specific policy including
 * rules, data fields, supported entities, and testing capabilities.
 */
const PolicyDetails = ({ policy, open, onClose }) => {
  const {
    activeTab,
    testResult,
    testing,
    testContent,
    loadingDomainDetails,
    handleTabChange,
    handleTestPolicy,
    setTestContent,
    getPolicyRules,
    getDataFields,
  } = usePolicyDetails(policy, open);

  if (!policy) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { height: '90vh' },
      }}
    >
      <PolicyDialogHeader policy={policy} onClose={onClose} />

      <DialogContent dividers>
        <Box>
          <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab label="Overview" />
            <Tab label="Rules" />
            <Tab label="Data Fields" />
            <Tab label="Entities" />
            <Tab label="Testing" />
          </Tabs>

          {activeTab === 0 && <PolicyOverviewTab policy={policy} />}

          {activeTab === 1 && (
            <PolicyRulesTab
              rules={getPolicyRules()}
              loading={loadingDomainDetails}
            />
          )}

          {activeTab === 2 && (
            <PolicyDataFieldsTab
              dataFields={getDataFields()}
              loading={loadingDomainDetails}
            />
          )}

          {activeTab === 3 && (
            <PolicyEntitiesTab entities={policy.supported_entities || []} />
          )}

          {activeTab === 4 && (
            <PolicyTestingTab
              policy={policy}
              testContent={testContent}
              onTestContentChange={setTestContent}
              onTestPolicy={handleTestPolicy}
              testing={testing}
              testResult={testResult}
            />
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PolicyDetails;
